import { Badge, Group, Tabs } from '@mantine/core';

import { contentTypes } from '../types';

const TAB_ORDER: contentTypes.ContentType[] = ['text', 'photo', 'video', 'audio', 'document'];

export type ContentTabValue = contentTypes.ContentType | 'categories';

const LABELS: Record<contentTypes.ContentType, string> = {
  text: 'Text',
  photo: 'Photo',
  video: 'Video',
  audio: 'Audio',
  document: 'Document',
};

type Props = {
  active: ContentTabValue;
  counts: Record<contentTypes.ContentType, number>;
  onChange: (tab: ContentTabValue) => void;
};

export const ContentTabs = ({ active, counts, onChange }: Props) => {
  return (
    <Tabs
      value={active}
      onChange={(value) => value && onChange(value as ContentTabValue)}
      variant="default"
    >
      <Tabs.List>
        {TAB_ORDER.map((type) => (
          <Tabs.Tab key={type} value={type}>
            <Group gap={6} wrap="nowrap">
              {LABELS[type]}
              <Badge size="xs" variant="light" radius="sm" color="gray">
                {counts[type]}
              </Badge>
            </Group>
          </Tabs.Tab>
        ))}
        <Tabs.Tab value="categories">
          <Group gap={6} wrap="nowrap">
            Категории
          </Group>
        </Tabs.Tab>
      </Tabs.List>
    </Tabs>
  );
};
